import { GetStaffAccountAssertionResp } from 'types/api/response/get-staff-account-assertion-resp'

import { api } from './api'

export const getStaffAccountAssertion = (targetUserId: number) =>
  api.post<GetStaffAccountAssertionResp>('secondary_users/assertions', {
    target_user_id: targetUserId,
  })
